import React from 'react'
import ShopingItemcards from '../../Cardbox/ShopingItemcards'
import Navbar from '../../Navbar'
import Last from '../Home/Last'
import Footer from '../../Footer'
import Epmulticarousel from './Epmulticarousel'
import Epcontainer from './Epcontainer'
import Epheader from './Epheader'
const Employeeperks = () => {
  return (
    <>
    <Navbar/>
    <Epheader/>
    <Epcontainer/>
   <Epmulticarousel/>
   <Epmulticarousel/>
   <Epmulticarousel/>
   <Epmulticarousel/>
   <Footer/>
    </>
  )
}

export default Employeeperks